import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var Notification;
(function (Notification) {
    let Flags;
    (function (Flags) {
        Flags[Flags["SMS_NOTIFICATION_ENABLE"] = 1] = "SMS_NOTIFICATION_ENABLE";
        Flags[Flags["VOICE_NOTIFICATION_ENABLE"] = 2] = "VOICE_NOTIFICATION_ENABLE";
        Flags[Flags["SMS_IF_CALL_FAILED"] = 4] = "SMS_IF_CALL_FAILED";
        Flags[Flags["PUSH_NOTIFICATION_ENABLE"] = 8] = "PUSH_NOTIFICATION_ENABLE";
        Flags[Flags["NOTIFICATION_TYPE_FIELD"] = 16] = "NOTIFICATION_TYPE_FIELD";
        Flags[Flags["SPEAKER_NOTIFICATION_ENABLE"] = 32] = "SPEAKER_NOTIFICATION_ENABLE";
    })(Flags = Notification.Flags || (Notification.Flags = {}));
    function isSmsEnabled(notification) {
        return isFlagSet(notification, Flags.SMS_NOTIFICATION_ENABLE);
    }
    Notification.isSmsEnabled = isSmsEnabled;
    function setSmsEnabled(notification, enabled) {
        return setFlag(notification, Flags.SMS_NOTIFICATION_ENABLE, enabled);
    }
    Notification.setSmsEnabled = setSmsEnabled;
    function isSmsIfCallFailed(notification) {
        return isFlagSet(notification, Flags.SMS_IF_CALL_FAILED);
    }
    Notification.isSmsIfCallFailed = isSmsIfCallFailed;
    function setSmsIfCallFailed(notification, enabled) {
        return setFlag(notification, Flags.SMS_IF_CALL_FAILED, enabled);
    }
    Notification.setSmsIfCallFailed = setSmsIfCallFailed;
    function isVoiceEnabled(notification) {
        return isFlagSet(notification, Flags.VOICE_NOTIFICATION_ENABLE);
    }
    Notification.isVoiceEnabled = isVoiceEnabled;
    function setVoiceEnabled(notification, enabled) {
        return setFlag(notification, Flags.VOICE_NOTIFICATION_ENABLE, enabled);
    }
    Notification.setVoiceEnabled = setVoiceEnabled;
    function isSpeakerNotificationEnabled(notification) {
        return isFlagSet(notification, Flags.SPEAKER_NOTIFICATION_ENABLE);
    }
    Notification.isSpeakerNotificationEnabled = isSpeakerNotificationEnabled;
    function setSpeakerNotificationEnabled(notification, enabled) {
        return setFlag(notification, Flags.SPEAKER_NOTIFICATION_ENABLE, enabled);
    }
    Notification.setSpeakerNotificationEnabled = setSpeakerNotificationEnabled;
    function isSpeakerEnabled(notification) {
        // Напоминание, что регистры с 0-2 должны быть занулены при использование внешнего динамика
        return (isFlagSet(notification, Flags.SPEAKER_NOTIFICATION_ENABLE) &&
            !isFlagSet(notification, Flags.SMS_NOTIFICATION_ENABLE) &&
            !isFlagSet(notification, Flags.VOICE_NOTIFICATION_ENABLE) &&
            !isFlagSet(notification, Flags.SMS_IF_CALL_FAILED));
    }
    Notification.isSpeakerEnabled = isSpeakerEnabled;
    Notification.get = createAccessors(arrayGetSet('notifications'), {
        name: 'оповещение',
        setting_register: 1,
        sms_text: '',
        voice_text: '',
        recipient_list: [],
    });
})(Notification || (Notification = {}));
